import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { PartnerBanner } from "@/components/site/PartnerBanner";
import { ConsultationForm } from "@/components/site/ConsultationForm";
import { Footer } from "@/components/site/Footer";
import { fetchLanding, fetchPrivacy } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

// Consultation lead page ("CHIEDI CONSULENZA GRATUITA" -> /request-consultation?ref={code}).
// Forwards the lead to the ZERAMI backend with the correct payload + GDPR consents.
export default function ConsultationPage() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || null;
  const canale = params.get("canale") || "web";
  const tracking = {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
  };
  const [partner, setPartner] = useState(null);
  const [servizi, setServizi] = useState(["sovraindebitamento", "saldo_stralcio"]);
  const [privacyText, setPrivacyText] = useState("");

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const p = await fetchPrivacy(ref || undefined);
        if (active && p?.privacy_text) setPrivacyText(p.privacy_text);
      } catch (_) {}
      if (ref) {
        try {
          const data = await fetchLanding(ref);
          if (!active) return;
          if (data?.found && data.partner) {
            const isPrincipale = (data.partner.tipo_partner || "").toLowerCase() === "principale";
            setPartner(isPrincipale ? null : data.partner);
            if (data.servizi?.length) setServizi(data.servizi);
          }
        } catch (_) {}
      }
    })();
    return () => {
      active = false;
    };
  }, [ref]);

  const backHref = ref ? `/partner/${ref}` : "/";

  return (
    <div className="relative">
      <Navbar />
      <PartnerBanner partner={partner} />
      <main className={partner ? "pt-9" : ""}>
        <section className="relative overflow-hidden bg-navy pb-2 pt-28 text-white lg:pt-32">
          <div className="mx-auto max-w-6xl px-4 lg:px-8">
            <a href={backHref} className="inline-flex items-center gap-2 text-sm font-semibold text-white/70 transition-colors hover:text-gold" data-testid="consult-back">
              <ArrowLeft className="h-4 w-4" /> Torna alla landing
            </a>
          </div>
        </section>
        <ConsultationForm code={ref} servizi={servizi} privacyText={privacyText} canale={canale} tracking={tracking} />
      </main>
      <Footer partner={partner} />
    </div>
  );
}
